import { render, staticRenderFns } from "./ProfileBody.vue?vue&type=template&id=4270f59e&scoped=true"
import script from "./ProfileBody.vue?vue&type=script&lang=js"
export * from "./ProfileBody.vue?vue&type=script&lang=js"
import style0 from "./ProfileBody.vue?vue&type=style&index=0&id=4270f59e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4270f59e",
  null
  
)

export default component.exports